import { baseURL } from './config.js';

import SockJS from 'sockjs-client';
import { Stomp } from '@stomp/stompjs';

const token = localStorage.getItem('token');
const socket = new SockJS(baseURL + `/endpointWiki?token=${token}`);
const stompClient = Stomp.over(socket);

export default stompClient;